export default __webpack_public_path__ + "static/decoration1-66d88a5373560af2b1adfbce4198c202.png";